import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/home-icon.module.scss'
import { Home } from 'lucide-react'

export default function HomeIcon(props) {
    const { contextStyles, hoverStyles, selectedStyles } = props
    return (
        <div className={cn(styles.homeIcon, contextStyles, hoverStyles, selectedStyles)}>
            <Home />
        </div>
    )
}
